







import { Component, Prop, Vue } from "vue-property-decorator";
import FscModal from "@/components/Modal/FscModal.vue";

@Component({
  components: { FscModal },
})
export default class ExaminerFeedbackModal extends Vue {
  public name = "ExaminerFeedbackModal";

  @Prop({ type: String })
  public modalId!: string;
}
